import Product from '~/Api/Product/Product';

import AllowsEmptyCalculator from './AllowsEmptyCalculator';
import ReferencePrices from './ReferencePrices';

export default class Item {
	product: Product;

	referencePrices: ReferencePrices;

	allowsEmptyCalculator: AllowsEmptyCalculator;

	packageSizeForSingleUnit: number | null;

	singleUnitPackageSize: boolean;

	selected: boolean;

	selectable: boolean;

	constructor(
		product: Product,
		referencePrices: ReferencePrices,
		allowsEmptyCalculator: AllowsEmptyCalculator,
		packageSizeForSingleUnit: number | null,
		singleUnitPackageSize: boolean,
		selected: boolean,
		selectable: boolean
	) {
		this.product = product;
		this.referencePrices = referencePrices;
		this.allowsEmptyCalculator = allowsEmptyCalculator;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.singleUnitPackageSize = singleUnitPackageSize;
		this.selected = selected;
		this.selectable = selectable;
	}
}
